import React, { Component } from "react";
import { ExternalLink, FileText } from 'lucide-react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import paymentBg from '../../images/paymet_summary-bg.svg';
import pdf from '../../resources/pricing-sheets/NULIFESPANRX-Introduction.Notification_3-27-25.pdf';
import { userService } from "../../_services";
import W9FormStarter from "./W9FormStarter";

class Payments_Summary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            IsnullPQKey: false,
            PQInKey: '',
            isInitiatingPayment: false,
            openStarterForm: false,
        };
        this.toogle_request_pop = this.initiatePQ.bind(this);
    }
    
    componentDidMount() {
        const { pqKey } = this.props;
        if (pqKey === "") {
            this.setState({ IsnullPQKey: true, PQInKey: '' });
        }
        else {
            this.setState({ IsnullPQKey: false, PQInKey: pqKey });
        }
    }
    
    initiatePQ = () => {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.setState({ isInitiatingPayment: true })
        setTimeout(() => {
            this.makepqInvite(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
        }, 100)
    }
    
    makepqInvite(UserId, UserName) {
        try {
            userService.pqInvite(UserId, UserName)
                .then(
                    apidata => {
                        if (apidata.length > 0) {
                            if (apidata[0].code == "1") {
                                this.setState({ IsnullPQKey: false, PQInKey: apidata[0].message });
                                window.open('https://nulifespanrx.mypayquicker.com/Welcome?InvitationId=' + apidata[0].message, '_blank');
                            } else {
                                this.setState({ isInitiatingPayment: false })
                            }
                        }
                    }
                );
        }
        catch (error) {
            this.setState({ isInitiatingPayment: false })
        }
    }
    
    closeStarterForm = () => {
        this.setState({ openStarterForm: false })
    }
    
    render() {
        const pqKey = this.state.PQInKey;
        let navlink = 'https://nulifespanrx.mypayquicker.com/Welcome?InvitationId=' + this.state.PQInKey;
        
        return (
            <Card 
                className="border-0 overflow-hidden"
                style={{
                    background: `#313131 url(${paymentBg}) no-repeat center top`,
                    backgroundSize: 'auto 153%'
                }}
            >
                <CardContent className="px-6 py-8 flex flex-col md:flex-row items-start md:items-end gap-6">
                    <div className="flex-shrink-0 max-w-[300px]">
                        <h3 className="text-2xl font-black text-white leading-8 mb-3">Payments</h3>
                        <p className="text-2xl text-white leading-7">Making payments is easier now!!</p>
                    </div>
                    
                    <div className="flex flex-col md:flex-row flex-wrap gap-2 md:ml-auto md:w-[400px] md:items-end">
                        <Button
                            variant="outline"
                            size="default"
                            asChild
                            className="bg-white hover:bg-gray-50 text-brand-dark border-white h-10 min-w-[120px]"
                        >
                            <a href={pdf} target="_blank" rel="noopener noreferrer">
                                <FileText className="h-4 w-4 mr-2" />
                                How it Works
                            </a>
                        </Button>
                        
                        {this.state.IsnullPQKey === false ? (
                            <Button
                                variant="secondary"
                                size="default"
                                asChild
                                className="h-10 min-w-[140px]"
                            >
                                <a href={navlink} target="_blank" rel="noopener noreferrer">
                                    My Payments
                                    <ExternalLink className="h-4 w-4 ml-2" />
                                </a>
                            </Button>
                        ) : (
                            <Button
                                variant="secondary"
                                size="default"
                                onClick={this.initiatePQ}
                                disabled={this.state.isInitiatingPayment}
                                className="h-10"
                                style={{ minWidth: this.state.isInitiatingPayment ? 'auto' : '160px' }}
                            >
                                {this.state.isInitiatingPayment ? 'Initiating Payment...' : (
                                    <>
                                        Initiate Payments
                                        <ExternalLink className="h-4 w-4 ml-2" />
                                    </>
                                )}
                            </Button>
                        )}
                    </div>
                </CardContent>
            </Card>
        )
    }
}

export default Payments_Summary;
